// extracted by mini-css-extract-plugin
export default {"customNavIcon":"customNavIcon_customNavIcon__Kkfw0","text":"customNavIcon_text__hiRCe"};